module.exports = __webpack_public_path__ + "img/round2-iteration2.5ca723c7.png";